import React from 'react';
import { connect } from 'react-redux';
import { deleteFileAnnouncement } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteFileAnnouncement,
};

function ModalDeleteFile({ data, deleteFileAnnouncement, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const file = data?.file;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteFileAnnouncement({ auth, history, data: item, file });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus file{' '}
        <span className='has-text-danger has-text-weight-semibold'>
          {file.filename}
        </span>
        ?
      </p>
      <div className='flex justify-end align-center px-4 pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteFile);
